import { render, staticRenderFns } from "./RepairRecordPage.vue?vue&type=template&id=721f51f5&scoped=true&"
import script from "./RepairRecordPage.vue?vue&type=script&lang=js&"
export * from "./RepairRecordPage.vue?vue&type=script&lang=js&"
import style0 from "./RepairRecordPage.vue?vue&type=style&index=0&id=721f51f5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721f51f5",
  null
  
)

export default component.exports